import { Suspense, useEffect } from 'react';
import { createBrowserHistory } from 'history';
import { Router, Switch, Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import routes, { ROUTE_TYPE } from './routes';

import Loading from 'components/Loading';
import Route from 'components/Route';
import Layout from 'pages/Layout';

const history = createBrowserHistory();

function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function MainRouter() {
  return (
    <Router history={history}>
      <ScrollRestoration />
      <Layout>
        <Switch>
          {routes.map((route, index) => (
            <Route
              key={index}
              exact
              strict
              path={route.path}
              rendered={route.type === ROUTE_TYPE.PUBLIC}
            >
              <Suspense fallback={<Loading />}>
                <route.component params={route.params} />
              </Suspense>
            </Route>
          ))}

          <Route>
            <Redirect to={{ pathname: '/' }} />
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
}
